export async function getRedirectUrl(code) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/redirect`, {
        method: 'POST',
        body: JSON.stringify({ IdentytyType: code }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}
export async function getMaildataList(session) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/maildatalist`, {
        method: 'POST',
        body: JSON.stringify({ Token: session }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}

export async function getParterList(Token) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/parterlist`, {
        method: 'POST',
        body: JSON.stringify({ Token }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}

export async function postMaildata(Token, maildata) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/postmaildata`, {
        method: 'POST',
        body: JSON.stringify({ Token: Token, maildata: maildata }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}

export async function postAttachment(token, attachment, envelopId) {

    const encodeToken = encodeURI(token);
    const formData = new FormData();
    formData.append("attachment", attachment, attachment.name);

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/postattachment/${encodeURIComponent(encodeToken)}/${encodeURIComponent(envelopId)}`, {
        method: 'POST',
        body: formData,
        headers: {
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }

    }).then(response => response.text()).then(data => data)

    return result;
}

export async function deleteToken(token) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/logout`, {
        method: 'POST',
        body: JSON.stringify({ Token: token }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}

export async function getSmsCode(claimNumber, email) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/getsms`, {
        method: 'POST',
        body: JSON.stringify({ claimNumber, email }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}

export async function checkSmsCode(smsCode, currentTime) {

    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/checksmscode`, {
        method: 'POST',
        body: JSON.stringify({ smsCode, currentTime }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.text()).then(data => data)

    return result;
}

export async function updateMaildata(token, id) {
    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/updatemaildata`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        },
        body: JSON.stringify({ token, id })
    }).then(response => response.text()).then(data => data)

    return result;
}

export async function GetToken() {
    const result = await fetch(`${process.env.REACT_APP_API_SERVICE}/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_ACCESS_TOKEN
        }
    }).then(response => response.json()).then(data => data)

    return result;
}